"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeService = void 0;
const BaseGraphQLService_1 = __importDefault(require("../BaseGraphQLService"));
const queries_1 = require("./queries");
const mutations_1 = require("./mutations");
class MeService extends BaseGraphQLService_1.default {
  constructor() {
    super(...arguments);
    this.queryCurrentUserInfo = (options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meStateQuery, {}, options, requestOptions);
      return response.data.me;
    });
    this.queryNotifications = (options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meNotificationQuery, {}, options, requestOptions);
      return response.data.me.notifications;
    });
    this.queryAllUnreadCount = (options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meAllUnreadCountQuery, {}, options, requestOptions);
      return response.data.me.state.counters;
    });
    this.queryCurrentHOAInfo = (options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meStateHOAQuery, {}, options, requestOptions);
      return response.data.me;
    });
    this.checkSession = (options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.checkSessionQuery, {}, options, requestOptions);
      return response.data.me;
    });
    this.queryCurrentUserInfoForRegistrationLocking = (options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meStateForRegistrationLocking, {}, options, requestOptions);
      return response.data.me;
    });
    this.bindSocialAccount = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.meBindSocialAccountMutation, variables, options, requestOptions);
      return response.data.me.bindSocialAccount;
    });
    this.changeNotifySettings = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.meSettingsNotifyMutation, variables, options, requestOptions);
      return response.data.me.settings.notify;
    });
    this.markAsNotSpammers = (variables, options, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.markAsNotSpammers, variables, options, requestOptions);
      return response.data.me.settings.markAsNotSpammers;
    });
    this.deleteNotification = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.meDeleteNotificationMutation, variables, options, requestOptions);
      return response.data.me.deleteNotification;
    });
    this.getAvailableHoas = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.meReloginQuery, variables, options, requestOptions);
      return response.data.me.relogin.hoas;
    });
    this.logout = () => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.meLogout, {});
      return response.data.me.userLogout;
    });
    this.markBellNotificationsAsRead = () => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.markBellNotificationsAsRead, {});
      return response.data.me.settings.markBellNotificationsAsRead;
    });
  }
}
exports.MeService = MeService;
const meQueryService = new MeService();
exports.default = meQueryService;